import React from "react";
import { motion } from "framer-motion";
import { tap, useMotionPrefs } from "@/lib/motion";

export default function MotionButton({
  children,
  className = "",
  success = false,
  type = "button",
  ...props
}) {
  const { isReduced } = useMotionPrefs();

  return (
    <motion.button
      type={type}
      className={`${className}${success ? " rp-btn-success" : ""}`}
      whileTap={isReduced ? undefined : tap}
      {...props}
    >
      {children}
    </motion.button>
  );
}
